import {
  ChangeJobRequest,
  EStoreExecutorTable,
  JobStatus,
  JobSub,
  Work,
} from "@project/shared-types";
import { useMemo, useState } from "react";
import { JobChangeAPI } from "../../api/JobsAPI";
import { Button } from "../../components/button/button";
import { FeedBack } from "../../components/FeedBack/FeedBack";
import { ImagePreview } from "../../components/ImagePreview/ImagePreview";
import { InfoCardJob } from "../../components/InfoCardJob/InfoCardJob";
import { InputDatePicker } from "../../components/InputDatePicker/InputDatePicker";
import { Loader } from "../../components/Loader/Loader";
import { _size, _style } from "../../core/core";
import { TimeStampToStringDate } from "../../hooks/timestamp_to_string_date";
import "./CardJob.css";
import { EditorJobSubFixed } from "./EditorJob/EditorJobSubFixed";
import { JobViewer, JobViewerProps } from "./JobViewer";

interface JobSubViewerProps extends JobViewerProps<JobSub> {
  is_edit: boolean;
}
interface JobRenderInfo {
  title: string;
  text?: string;
  image?: string;
}
const getInfoForRender = (job: JobSub, work: Work): JobRenderInfo[] => {
  const methods: Record<JobStatus, () => JobRenderInfo[]> = {
    [JobStatus.DO]: () => [
      {
        title: "Запланировано:",
        text: TimeStampToStringDate(job.date_public),
      },
    ],
    [JobStatus.WORK]: () => [
      {
        title: "Выполняет:",
        text: work.nickname ? work.nickname : "Скоро укажет",
      },
      {
        title: "Начал:",
        text: TimeStampToStringDate(work.date_published),
      },
    ],
    [JobStatus.WAIT_CHECK]: () => [
      {
        title: "Отправлено на проверку:",
        text: TimeStampToStringDate(job.date_public),
      },
      {
        title: "Скриншот исполнителя:",
        image: work.image,
      },
    ],
    [JobStatus.WAIT_PAY]: () => [
      {
        title: "Отправлено на проверку:",
        text: TimeStampToStringDate(job.date_public),
      },
      {
        title: "Скриншот исполнителя:",
        image: work.image,
      },
    ],
    [JobStatus.CLOSE]: () => [
      {
        title: "Отправлено на проверку:",
        text: TimeStampToStringDate(job.date_public),
      },
      {
        title: "Скриншот исполнителя:",
        image: work.image,
      },
    ],
    [JobStatus.NO_HOLD]: () => [],
    [JobStatus.NO_FIND_REVIEW]: () => [],
    [JobStatus.WAIT_CHECK2]: () => [],
    [JobStatus.NO_WORK]: () => [],
    [JobStatus.DELETE]: () => [],
  };

  return methods[job.status]?.() || [];
};
export const JobSubViewer: React.FC<JobSubViewerProps> = ({
  job_data,
  work,
  children,
  onClick,
  is_edit,
}) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [job, setJob] = useState(job_data);
  const [date, setDate] = useState(job.date_public);
  const [isChange, setIsChange] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    onClick?.(e);
    e.stopPropagation();
    e.preventDefault();
    setOpenModal((prev) => !prev);
  };

  const fetchChangeJob = async () => {
    try {
      if (!is_edit) return;
      setIsLoading(true);
      const requestData = {
        order_id: job.order_id,
        job_id: job.id,
        text: undefined,
        date_public: date,
        file_ids: [],
      } as ChangeJobRequest;
      const response = await JobChangeAPI(requestData);
      setIsLoading(false);
      setIsChange(false);
      setJob(response.job as JobSub);
    } catch (error) {
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };
  const renderInfo = useMemo(() => {
    if (job.status == JobStatus.DO) {
      return [
        {
          title: "Запланировано:",
          text: TimeStampToStringDate(job.date_public),
        },
      ];
    }
    if (work) {
      return getInfoForRender(job, work);
    }
    return [];
  }, [job, work]);
  const getImageUrl = (image: string) => {
    if (image.includes("jobs")) return image;
    return `/media/content/${EStoreExecutorTable.WORKS}/${image}.webp`;
  };
  return (
    <JobViewer job_data={job} work={work} onClick={handleClick}>
      {is_edit && job.status == JobStatus.DO ? (
        <div className="card-job-b">
          <InputDatePicker
            value={date}
            setValue={setDate}
            labelOutside="Запланировать"
          ></InputDatePicker>
          {isChange && (
            <Button
              size={_size.S}
              style={_style.secondary2}
              width={"100%"}
              onClick={() => fetchChangeJob()}
            >
              {isLoading ? <Loader isLoading /> : "Сохранить"}
            </Button>
          )}
        </div>
      ) : (
        <div className="card-job-b">
          {renderInfo.map((item) => (
            <>
              {item.image ? (
                <InfoCardJob title={item.title} text={item.text} />
              ) : (
                <ImagePreview
                  title={item.title}
                  url={getImageUrl(work?.image || "")}
                />
              )}
            </>
          ))}
          {(job.status == JobStatus.CLOSE ||
            job.status == JobStatus.WAIT_PAY) && (
            <FeedBack
              title="Оцените работу исполнителя"
              id={job.id}
              is_order={false}
            />
          )}
          <Button onClick={() => setOpenModal(true)}>Подробнее</Button>
        </div>
      )}
      <EditorJobSubFixed
        order_id={job.order_id}
        is_active={openModal}
        set_is_active={setOpenModal}
        job_data={job}
      ></EditorJobSubFixed>
    </JobViewer>
  );
};
